const filterInit = (el: HTMLElement) => {
  const title: HTMLElement = el.querySelector('.filter-single__title');
  const filters: HTMLElement = el.querySelector('.filter-single__filters');
  const filtersWrapper: HTMLElement = el.querySelector('.filter-single__filters-wrapper');
  const body: HTMLElement = document.querySelector('.body');
  let toggles:NodeListOf<HTMLElement> = el.querySelectorAll('.facetwp-toggle');

  title.addEventListener('click', (e) => {
    el.classList.toggle('active');
    e.preventDefault();
    if (filters.clientHeight) {
      filters.style.height = '0';
    } else {
      filters.style.height = `${filtersWrapper.clientHeight}px`;
    }
  });

  if (el.classList.contains('active')) {
    filters.style.height = `${filtersWrapper.clientHeight}px`;
  }

  toggles.forEach((toggle: HTMLElement) => {
    toggle.addEventListener('click', () => {
      setTimeout(() => {
        filters.style.height = `${filtersWrapper.clientHeight}px`;
      }, 10);
    });
  });

  document.addEventListener('facetwp-loaded', () => {
    window.scrollTo({
      top: body.offsetTop,
      left: 0,
      behavior: 'smooth',
    });
    toggles = el.querySelectorAll('.facetwp-toggle');

    if (filters.clientHeight) {
      filters.style.height = `${filtersWrapper.clientHeight}px`;
    }

    toggles.forEach((toggle: HTMLElement) => {
      toggle.addEventListener('click', () => {
        setTimeout(() => {
          filters.style.height = `${filtersWrapper.clientHeight}px`;
        }, 10);
      });
    });
  });
};

export default filterInit;
